import React from 'react'

function BrochureIndoor() {
  return (
    <embed src="\pdfs\E1.5.8.0_Displacement_ventilation_for_indoor_firing_ranges_06.2014_Bildschirmversion_kr.pdf" width="100%" height="2100px" />
  )
}

export default BrochureIndoor